import { render } from "./ScSide.vue?vue&type=template&id=756e2f33&scoped=true&ts=true"
import script from "./ScSide.vue?vue&type=script&lang=ts"
export * from "./ScSide.vue?vue&type=script&lang=ts"

import "./ScSide.vue?vue&type=style&index=0&id=756e2f33&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756e2f33"]])

export default __exports__